"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectCell = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const Link_1 = require("../Link");
const index_1 = require("../index");
/**
 * Renders a table cell that encapsulates a `SubjectCardPopover` for displaying detailed information,
 * optionally followed by a clickable link and secondary text. The `Link` is only rendered if both `linkProps`
 * and `text` are provided. The secondary text is rendered as a caption and can be styled using the `Typography`
 * component from Material-UI.
 *
 * @param {ISubjectCellProps<T>} props - The props passed to the component.
 * @param {ListItemProps} [props.ListItemProps] - Optional props for the `ListItem` component.
 * @param {ISubjectCardProps} props.SubjectCardPopoverProps - Props for the `SubjectCardPopover` component.
 * @param {string} props.columnId - Identifier for the table column.
 * @param {Omit<ILinkProps, "children" | "component"> & { component: React.ElementType }} [props.linkProps] - Optional props for the `Link` component; required for rendering the link.
 * @param {string} [props.text] - Optional text for the link; the link is rendered only if this is provided.
 * @param {string} [props.secondaryText] - Optional secondary text displayed below the link or main content.
 * @param {Partial<TypographyProps<"div">>} [props.secondaryTextTypographyProps] - Optional props to style the `Typography` component that renders the secondary text.
 *
 * @category Component
 * @template T - Extends string to specify the type of column identifier.
 */
const SubjectCell = ({ ListItemProps, SubjectCardPopoverProps, columnId, linkProps, secondaryText, secondaryTextTypographyProps, text, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps },
        react_1.default.createElement(ListItem_1.default, { dense: true, disableGutters: true, ...ListItemProps },
            react_1.default.createElement(index_1.SubjectCardPopover, { ...SubjectCardPopoverProps }),
            text && react_1.default.createElement(Link_1.Link, { ...linkProps }, text),
            secondaryText && (react_1.default.createElement(Typography_1.default, { component: "div", variant: "caption", ...secondaryTextTypographyProps }, secondaryText)))));
};
exports.SubjectCell = SubjectCell;
exports.default = exports.SubjectCell;
